import {Routes} from "@angular/router";
import {LoginComponent} from "./core/authentication/login/login.component";
import {HomeComponent} from "./components/home/home.component";
import {PlanDetailsComponent} from "./components/plan-details/plan-details.component";
import {AuthGuard} from "./core/guards/auth.guard";
import {LoggedInAuthGuard} from "./core/guards/login-auth.guard";
import {DevicesPageComponent} from "./components/devices-page/devices-page.component";
import {SsoComponent} from "./components/sso.component";

export const routes: Routes = [
    {path: "home", component: HomeComponent, canActivate: [AuthGuard]},
    {path: "devices", component: DevicesPageComponent, canActivate: [AuthGuard]},
    {
        path: "planDetails",
        component: PlanDetailsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "login",
        component: LoginComponent,
        canActivate: [LoggedInAuthGuard],
    },
    {
        path: "sso",
        component: SsoComponent,
    },

    {path: "**", redirectTo: "/login", pathMatch: "full"},
];
